// extracted by mini-css-extract-plugin
export var container = "_ax-0";
export var containerTopRight = "_ax-1";